<template>
    <div class="d-none d-md-block">
        <span>
            <router-link class="cursorPoint"
                         to="/HomePage"
                         :data-ga="`${gaData}麵包屑|健康及保險知識+`">健康及保險知識+</router-link>
        </span>
        <span v-for="(item, index) in breadCrumbList"
              :key="index">
            <ChevronRightIcon size="1.5x"
                              stroke-width="1"
                              class="mb-1 ml-n1" />
            <router-link v-if="item.link!==''"
                         :to="item.link"
                         :data-ga="`${gaData}麵包屑|${item.name}`">
                <label class="cursorPoint ml-n1"> {{item.name}}</label>
            </router-link>
            <label class="ml-n1"
                   v-else> {{item.name}}</label>
        </span>
        <!-- <span>/ 所有排行 </span> -->
    </div>
</template>
<script>
import { ChevronRightIcon } from 'vue-feather-icons';

export default {
    name: 'BreadCrumbs',
    components: {
        ChevronRightIcon,
    },
    props: {
        breadCrumbList: {
            type: Array,
            require: true,
            // ga: (...)
            // link: (...)
            // name: (...)
        },
        gaData: {
            type: String,
            default: '健康及保險知識+｜',
        },
    },
    created() { }
};
</script>
<style lang="scss" scoped>
a {
    color: #333;
    &:hover {
        color: $primary;
    }
}
</style>
